module.exports = __webpack_public_path__ + "static/media/YEM.89aa0894.svg";